import { EmployeeRecord } from '../EmployeeRecord.model';
import { Job } from '../focusDataModels/Job';

export class LaborScheduleItem {
	pk: string; //:venueKey
	sk: string; //labor_schedule_startDateUnix
	name: string;
	startDateUnix: number;
	externalId: string;
	startDate: string;
	endDate: string;
	status: number;

	LaborScheduleEntry: LaborScheduleEntry[];

	employeeLaborScheduleEntries: EmployeeLaborScheduleEntry[] = [];

	public constructor(init?: Partial<LaborScheduleItem>) {
		Object.assign(this, init);
	}
}

export class EmployeeLaborScheduleEntry {
	employeeId: number;
	employee: EmployeeRecord;
	scheduleEntryDays: ScheduleEntryDay[] = [];
	cost: EmployeeLaborScheduleEntryCost;
	display: boolean = true;

	public constructor(init?: Partial<EmployeeLaborScheduleEntry>) {
		Object.assign(this, init);
		for (let i = 0; i <= 6; i++) {
			this.scheduleEntryDays.push(
				new ScheduleEntryDay({
					dayOfWeek: i,
				})
			);
		}
		this.cost = new EmployeeLaborScheduleEntryCost();
	}
}

export class EmployeeLaborScheduleEntryCost {
	regularHours: number = 0;
	regularCost: number = 0;
	regularMinutes: number = 0;
	dailyOvertimeHours: number = 0;
	dailyOvertimeCost: number = 0;
	weeklyOvertimeHours: number = 0;
	weeklyOvertimeCost: number = 0;
	totalMinutes: number = 0;

	public constructor(init?: Partial<EmployeeLaborScheduleEntryCost>) {
		Object.assign(this, init);
	}
}

export class ScheduleEntryDay {
	dayOfWeek: number;
	date: string;
	entries: LaborScheduleEntry[] = [];

	public constructor(init?: Partial<ScheduleEntryDay>) {
		Object.assign(this, init);
	}
}

export class LaborScheduleEntry {
	externalId: string;
	employeeId: number;
	jobScheduleId: string;
	startDateTime: string;
	endDateTime: string;
	jobId: number;

	startDay: number;
	payRate: number;
	hours: number;
	minutes: number;
	cost: number;
	shiftColor: string;
	shiftNotes: string;

	employee: EmployeeRecord;

	job: Job;

	newEntry: boolean;

	public constructor(init?: Partial<LaborScheduleEntry>) {
		Object.assign(this, init);
	}
}

export enum LaborScheduleStatus {
	DRAFT = 0,
	SAVED = 1,
	SENT = 2,
	PUBLISHED = 3,
	PUBLISHERROR = 4,
}
